import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Translate, useCreatePath, useResourceContext } from "ra-core";
import { Link } from "react-router";

export type CreateButtonProps = {
  label?: string;
  resource?: string;
};

export const CreateButton = ({
  label,
  resource: targetResource,
}: CreateButtonProps) => {
  const resource = useResourceContext();
  const createPath = useCreatePath();
  const link = createPath({
    resource: targetResource ?? resource,
    type: "create",
  });
  return (
    <Button
      asChild
      variant="outline"
      className="!bg-[#354660] !text-white hover:!bg-[#29374B] hover:!text-white focus:!text-white active:!text-white visited:!text-white !border-transparent no-underline dark:!border-input dark:!bg-transparent dark:!text-foreground dark:hover:!bg-accent dark:hover:!text-foreground dark:visited:!text-foreground"
    >
      <Link to={link} onClick={stopPropagation}>
        <Plus />
        <Translate i18nKey={label ?? "ra.action.create"}>
          {label ?? "Create"}
        </Translate>
      </Link>
    </Button>
  );
};

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
